import { Component, ViewContainerRef, ViewChild, ComponentFactoryResolver, OnInit} from '@angular/core'; 
import { AuthenticationService } from '@services/security';
import { USER_ROLES } from '@shared/app-consts'; 

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit{

  @ViewChild('dashboardContainer', { read: ViewContainerRef, static: true }) dashboardContainerRef: ViewContainerRef;
  readonly USER_ROLES = USER_ROLES;
  constructor(private componentFactoryResolver: ComponentFactoryResolver, private authenticationService: AuthenticationService) {}

  ngOnInit() {
    this.loadDashboard();
  }

  loadDashboard(){
    
  }

}
